export default {
  namespaced: true,
  state: {
    surveysList: [],
    survey: null,
    lastShowTime: [],
    hasSurvey: false,
  },
  actions: {
    async GetSurveys({ commit, state, rootGetters }, profileId) {
      const response = await rootGetters.ax.post('survey/api/surveys/surveys-list', {
        profile_id: profileId,
      });
      if (!response || !response.data || !Array.isArray(response.data.surveys)) {
        throw new Error('Surveys are missing from the response');
      }
      const timestamp = Math.floor(Date.now() / 1000);
      const surveys = response.data.surveys.filter((item) => {
        const previous = state.lastShowTime.find(shown => shown.id === item.id);
        return item.enabled
          && (!previous || timestamp - previous.time > item.frequency_hours * 3600);
      });
      commit('SetSurveysList', surveys);
      commit('SetSurvey', surveys[0] || {});
      commit('SetSurveyFlag', surveys.length > 0);
      return surveys;
    },
    InitialStoreSurveys({ commit }) {
      commit('InitialStoreSurveys');
    },
  },
  mutations: {
    SetSurveysList(state, surveys) {
      state.surveysList = surveys;
    },
    SetSurvey(state, payload) {
      state.survey = payload;
    },
    SetSurveyFlag(state, payload) {
      state.hasSurvey = payload;
    },
    InitialStoreSurveys(state) {
      state.surveysList = [];
      state.survey = null;
      state.lastShowTime = [];
      state.hasSurvey = false;
    },
    SetLastShowTime(state, payload) {
      if (state.lastShowTime.length && payload.time === null) {
        const findIndexSurvey = state.lastShowTime.findIndex(x => x.id === payload.id);
        (findIndexSurvey !== -1) && state.lastShowTime.splice(findIndexSurvey, 1);
      } else if (state.lastShowTime.length && payload.time !== null) {
        const findIndexSurvey = state.lastShowTime.findIndex(x => x.id === payload.id);
        if (findIndexSurvey !== -1) {
          state.lastShowTime[findIndexSurvey].time = payload.time;
        } else {
          state.lastShowTime.push({ id: payload.id, time: payload.time });
        }
      } else {
        state.lastShowTime.push({ id: payload.id, time: payload.time });
      }
    },
  },
};
